<template>
  <router-link v-if="product" :to="routerAttr" @click.native="trackGtm" class="is-flex u-w100 card-offer-wrapper">
    <div class="card card--offer" v-bind:class="cssClass">
      <div class="card-image">
        <figure class="image" aria-hidden="true">
          <picture>
            <!-- <source :srcset="`https://assets.urlaubsgutschein.kaufen/i/crop?width=120&height=350&gravity=smart&quality=50&interlace=true&type=auto&file=${product.image}`" media="(max-width: 412px)" />  -->
            <source :srcset="`https://assets.urlaubsgutschein.kaufen/i/crop?width=440&height=200&gravity=centre&quality=50&interlace=true&type=auto&file=${product.image}`" media="(max-width: 440px)" />
            <!-- for stacked -->
            <source :srcset="`https://assets.urlaubsgutschein.kaufen/i/crop?width=200&height=220&gravity=centre&quality=50&interlace=true&type=auto&file=${product.image}`" media="(max-width: 520px)" />
            <source :srcset="`https://assets.urlaubsgutschein.kaufen/i/crop?width=290&height=220&gravity=centre&quality=50&interlace=true&type=auto&file=${product.image}`" media="(max-width: 768px)" />

            <!-- <source :srcset="`https://assets.urlaubsgutschein.kaufen/i/crop?width=230&height=300&gravity=smart&quality=50&interlace=true&type=auto&file=${product.image}`" media="(max-width: 768px)" /> -->
            <source :srcset="`https://assets.urlaubsgutschein.kaufen/i/crop?width=480&height=300&gravity=centre&quality=50&interlace=true&type=auto&file=${product.image}`" media="(max-width: 1023px)" />
            <source :srcset="`https://assets.urlaubsgutschein.kaufen/i/crop?width=288&height=180&gravity=centre&quality=50&interlace=true&type=auto&file=${product.image}`" media="(max-width: 1215px)" />
            <source :srcset="`https://assets.urlaubsgutschein.kaufen/i/crop?width=352&height=220&gravity=centre&quality=50&interlace=true&type=auto&file=${product.image}`" media="(max-width: 1407px)" />
            <source :srcset="`https://assets.urlaubsgutschein.kaufen/i/crop?width=416&height=260&gravity=centre&quality=50&interlace=true&type=auto&file=${product.image}`" media="(min-width: 1408px)" />
            <img :src="`https://assets.urlaubsgutschein.kaufen/i/resize?width=720&quality=50&interlace=true&type=auto&file=${product.image}`" :alt="product.contact.name" loading="lazy" fetchpriority="low" />
          </picture>
        </figure>
        <!-- <Badge v-if="$options.filters.haspromotion(product, 'InsuranceIncluded')" :text="`Gutschein<br>Garantie`" :color="['rgba(253, 216, 53, 1)', 'rgba(249, 168, 37, 1)']" class="card-offer__badge" /> -->

        <img
          v-if="$options.filters.haspromotion(product, 'Custom:ssv2021') && $whitelabel.campaignsEnabled"
          :src="`https://assets.urlaubsgutschein.kaufen/i/resize?width=70&quality=50&type=auto&interlace=true&file=whitelabel/adac/campaigns/ssv-bubble.png`"
          alt="15% SSV-Rabatt on top!"
          loading="lazy"
          class="card-offer__badge--right"
        />

        <!-- <Badge v-if="this.$whitelabel.short.toLowerCase() === 'greenstorm'" :text="`Geld-zurück<br>Garantie`" :color="['rgba(133, 176, 19, 1)', 'rgba(133, 176, 19, 1)']" class="card-offer__badge  c-badge--greenstorm" /> -->
      </div>
      <div class="card-content">
        <div class="title card__title is-5 is-size-4-widescreen">
          <OfferTags :offer="product"></OfferTags>

          <span class="is-size-7 has-text-weight-normal is-family-sans-serif is-inline-block-mobile">{{ product.contact.city }}, {{ product.contact.state }}</span
          ><br />
          {{ product.contact.name }}<br /><StarDisplay :stars="product.contact.category" />
        </div>

        <p class="subtitle is-6 is-size-7-mobile card-subtitle">
          {{ product.display }}
        </p>

        <div class="is-size-7-mobile has-text-weight-bold">
          <!-- <p v-for="room in product.rooms" :key="room.name" class="is-hidden-mobile">{{ room.name }}</p> -->
          <span class="is-inline-block"><MinMaxDisplay :min="product.nights.min" :max="product.nights.max" />{{ $t('general.nights') }}</span
          >,
          <span class="is-inline-block" v-for="board in product.boards" :key="board.short">{{ board.longName }}</span>
          <!-- <MinMaxDisplay :min="product.persons.min" :max="product.persons.max" />P
          |-->
        </div>

        <div class="columns u-is-vend is-2 is-variable is-multiline is-mobile mt-2">
          <div class="column is-12-touch is-12-tablet is-5-fullhd card__btnwrap is-hidden-print" v-if="$whitelabel.hasOfferCta">
            <button tabindex="-1" class="button card__btn  is-size-6-fullhd is-block u-w100 u-no-radius is-primary mt-4">{{ $t('general.to-offer') }}</button>
          </div>
          <div class="column is-12-touch is-12-tablet is-7-fullhd card__pricewrap" v-bind:class="{'is-12': !$whitelabel.hasOfferCta}">
            <div class="has-text-right">
              <ReductionDisplay ref="reductionTag" v-if="$whitelabel.showReduction" :beforePrice="product.price.list" :afterPrice="product.price.total" size="is-large" class="card-tag" />

              <p v-if="!$whitelabel.showReduction"><ReductionDisplay ref="promoTag" v-if="this.reductionInfo.hasActiveReduction" :beforePrice="product.price.display" :afterPrice="displayPrice" size="is-medium" class="card-tag" /></p>
              <p v-if="$whitelabel.showReduction && this.reductionInfo.hasActiveReduction && displayPrice < product.price.display"><ReductionDisplay ref="promoTag" :beforePrice="product.price.display" :afterPrice="displayPrice" :textOnly="true" /> {{ $t('general.rabatt') }}</p>

              <!-- <p class="is-size-7" v-if="reductionInfo.hasActiveReduction">mit Promtioncode statt {{ variant.price.display | amount }} (<ReductionDisplay :beforePrice="variant.price.display" v-if="reductionInfo.hasActiveReduction" :afterPrice="displayPrice" :textOnly="true" />)</p> -->

              <p class="is-linethrough is-size-5" v-if="this.reductionInfo.hasActiveReduction && displayPrice < product.price.display">{{ $t('general.instead-of') }} {{ product.price.display | amount }}</p>
              <div class="has-text-weight-bold card-offer__price-content" v-bind:class="{'is-size-7 is-size-6-touch': $whitelabel.hasOfferCta, 'is-size-6 is-size-7-mobile': !$whitelabel.hasOfferCta}">
                <!-- stattpreis für deals-->
                <p v-if="$options.filters.hasanypromotion(product) && !$options.filters.haspromotion(product, 'Custom:xmas21')" class="is-size-6 has-text-grey-light has-text-weight-normal is-linethrough--classic">
                  {{ $t('general.instead-of') }} {{ product.price.currency | currency }} {{ product.persons.max === 2 ? product.price.list / 2 : product.price.list | amount }}
                </p>

                <span class="card-offer__price-prefix" v-if="!$whitelabel.hasOfferCta">{{ product.price.prefix }}</span>
                <span class="card-offer__price-prefix" v-if="$whitelabel.hasOfferCta">{{ product.price.prefix | pricePrefixAbbr }}</span
                >&nbsp;
                <span class="is-size-3 is-size-4-mobile is-inline-block  card-offer__price-wrapper">
                  {{ product.price.currency | currency }}
                  <span class="card-offer__price is-inline-block" ref="price">{{ product.price.display | amount }}</span>
                </span>
              </div>
              <small v-if="$whitelabel.showTotalPrice" class="has-text-grey-light has-text-weight-normal is-size-7-mobile"
                >{{ product.persons.min }} {{ $t('general.persons') }} {{ product.price.currency | currency }} <span ref="priceTotal">{{ product.price.total | amount }}</span></small
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </router-link>
</template>

<script>
import StarDisplay from '@/components/StarDisplay'
import MinMaxDisplay from '@/components/MinMaxDisplay'
import ReductionDisplay from '@/components/ReductionDisplay'
//import Badge from '@/components/Badge'
import OfferTags from '@/components/Offertags'
import {mapGetters} from 'vuex'
import anime from 'animejs'

export default {
  name: 'OfferElement',
  components: {
    StarDisplay,
    MinMaxDisplay,
    ReductionDisplay,
    //Badge,
    OfferTags,
  },
  props: {
    product: {
      type: Object,
    },
  },
  data() {
    return {
      img: '',
      cssClass: '',
      //hasTraveldealTag: false,
    }
  },
  computed: {
    ...mapGetters({
      reductionInfo: 'displayReduction',
      reductionActive: 'displayReductionActive',
    }),
    displayPrice() {
      if (this.reductionInfo.hasActiveReduction) {
        return this.reductionInfo.reductionFx(this.product.price.display)
      } else {
        return this.product.price.display
      }
    },
    totalPrice() {
      if (this.reductionInfo.hasActiveReduction) {
        return this.reductionInfo.reductionFx(this.product.price.total)
      } else {
        return this.product.price.total
      }
    },
    routerAttr() {
      if (this.product.slug && this.product.slug.length > 0) {
        return {
          name: 'urlaub',
          params: {
            slug: this.product.slug,
            contact: this.product.contact.slug,
          },
        }
      }
      return {
        name: 'hotel',
        params: {
          id: this.product.id,
          name: this.$options.filters.removeSpecialChars(this.product.contact.name),
        },
      }
    },
  },
  methods: {
    animatePrices() {
      anime({
        // this.$anime({
        targets: this.$refs.price,
        innerHTML: [
          this.displayPrice
            .toFixed(2)
            .replace('.', ',')
            .replace(',00', ',-'),
        ],
        duration: 2000,
        easing: 'easeInOutExpo',
        round: 1,
      })

      anime({
        // this.$anime({
        targets: this.$refs.reductionTag,
        opacity: 1,
        transformY: 0,
        duration: 500,
        easing: 'easeInOutExpo',
      })

      anime({
        // this.$anime({
        targets: this.$refs.priceTotal,
        innerHTML: [
          this.totalPrice
            .toFixed(2)
            .replace('.', ',')
            .replace(',00', ',-'),
        ],
        duration: 2000,
        easing: 'easeInOutExpo',
        round: 1,
      })
    },

    trackGtm() {
      this.$eventDispatcher.dispatch('offer_clicked', {
        product: this.product,
      })
    },
  },
  mounted() {
    if (this.reductionInfo.hasActiveReduction) {
      this.animatePrices()
    }

    if (this.$options.filters.haspromotion(this.product, 'Custom:blackweek21') && this.$whitelabel.campaignsEnabled) {
      this.cssClass = 'offer--blackfriday'
    }
    if (this.$options.filters.haspromotion(this.product, 'Custom:valentin22') && this.$whitelabel.campaignsEnabled) {
      this.cssClass = 'offer--valentine'
    }
    if (this.$options.filters.haspromotion(this.product, 'Custom:ostern21') && this.$whitelabel.campaignsEnabled) {
      this.cssClass = 'offer--easter'
    }

    // this.hasTraveldealTag =
    //   this.$whitelabel.campaignsEnabled &&
    //   (this.$options.filters.haspromotion(this.product, 'Custom:italia') ||
    //     this.$options.filters.haspromotion(this.product, 'Custom:watitalia') ||
    //     this.$options.filters.haspromotion(this.product, 'Custom:de22') ||
    //     this.$options.filters.haspromotion(this.product, 'Custom:gardasee') ||
    //     this.$options.filters.haspromotion(this.product, 'Custom:suedtirol'))
  },
  watch: {
    reductionActive() {
      this.animatePrices()
    },
  },
}
</script>

<style lang="scss">
.card--offer {
  width: 100%;
  box-shadow: 0 2px 8px rgba(10, 10, 10, 0.1);
  border-radius: 4px;

  @media screen and (min-width: 769px) {
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .card-content {
      display: flex;
      flex-direction: column;
      //flex-basis: 100%;
      justify-content: space-between;
      flex-basis: auto; //needed for displaying correctly in ie11
    }
  }

  .card-subtitle {
    margin-bottom: 0;
  }
}

.card-offer__badge {
  position: absolute;
  left: 1.5rem;
  bottom: 1rem;
}

.card-offer__badge--right {
  position: absolute;
  bottom: 1rem;
  right: 1.5rem;
}

.card-content {
  height: 100%;
}

.card-tag {
  position: absolute;
  top: 1rem;
  left: 1rem;
  z-index: 1; //avoid overlapping of other elements
}

.card__btnwrap {
  padding-top: 0;
}

// .tags--deal {
//   .tag {
//     margin-bottom: 0;
//   }
// }

@media only screen and (max-width: 1215px) and (min-width: 1024px) {
  .card-offer__price {
    font-size: 1.8rem !important;
    letter-spacing: -1px;
  }
}

@media only screen and (max-width: 1407px) {
  // .card__btnwrap, .card_pricewrap{
  //     flex: none;
  //     width: 100%;
  // }

  .card__btnwrap {
    order: 2;
  }
  .card__pricewrap {
    order: 1;
    padding-top: 0;
  }

  .card__btn {
    margin-top: 0;
  }

  .card-content {
    padding: 0.5rem 1rem;
  }
}
// .card--offer {
//   .card__title {
//     text-overflow: ellipsis;
//     white-space: nowrap;
//     overflow: hidden;
//   }

//display: flex; //
//flex-direction: column;

// .card-content {
//   flex-grow: 1;
//   display: flex;
//   flex-wrap: wrap;

//   & > * {
//     flex-basis: 100%;
//   }
// }
//}

@media screen and (max-width: 768px) {
  .card--offer {
    display: flex;
    flex-wrap: nowrap;
  }

  .card-image {
    flex-basis: 40%;

    .image {
      height: 100%;

      img {
        height: 100%;
        object-fit: cover;
      }
    }
  }
  .card-content {
    flex-basis: 60%;
    padding: 0.75rem 1rem;

    .icon {
      height: 1rem;
      width: 1rem;
    }
  }

  .card-subtitle {
    min-height: unset;
  }

  .card-offer__badge {
    transform: rotate(-5deg) scale(0.8) !important;
    left: 1rem;
    bottom: 0.5rem;
  }

  .card-offer__badge--right {
    transform: scale(0.8) !important;
    bottom: 0.5rem;
    right: 1rem;
  }

  .card-tag {
    .tag {
      font-size: 1rem !important;
    }
  }
}

/*for stacking img over content*/
@media screen and (max-width: 440px) {
  .card--offer {
    flex-wrap: wrap;
  }
  .card-image,
  .card-content {
    flex-basis: 100%;

    img {
      aspect-ratio: 16 / 10;
      object-fit: cover;
    }
  }
}

.offer--blackfriday {
  .card-tag {
    .tag {
      background-color: #000 !important;
    }
  }
}

@media screen and (min-width: 769px) {
  .card-image {
    img {
      aspect-ratio: 16 / 10;
      object-fit: cover;
    }
  }
}

// .offer--valentine {
//   .card-tag {
//     .tag {
//       background-color: #000 !important;
//     }
//   }
// }

@media print {
  .column:has(.card-offer-wrapper) {
    width: 100%;

    .card--offer {
      display: flex;
    }

    .card-image {
      flex: 0 0 30%;

      .image,
      img {
        height: 100%;
        object-fit: cover;
      }

      img {
        position: absolute;
        top: 0;
      }
    }

    .card-content {
      flex: 0 0 70%;
      padding: 0.75rem;
    }

    .card-subtitle {
      min-height: 0;
    }
  }
}
</style>
